import React from 'react';
import {Link } from 'react-router-dom';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';

export default function Rightbar() {
return (
<>  

<Nav className="flex-column pt-2">
<p>Andrey Orlov</p>
<h1>Dashboard</h1>
<Nav.Item className="active">
<Nav.Link href="Dashboard">
Dashboard Home
</Nav.Link>
</Nav.Item>

<Nav.Item>
<Nav.Link href="#"> 
Terms & Conditions (PDF)
</Nav.Link>
</Nav.Item>

<Nav.Item>
<Nav.Link href="#">
Show Schedule
</Nav.Link>
</Nav.Item>

<Nav.Item>
<Nav.Link href="#">
Rules and Regulations
</Nav.Link>
</Nav.Item>

<Nav.Item>
<Nav.Link href="yourprogramming">
Your Programming
</Nav.Link>
</Nav.Item>

<Nav.Item>
<Nav.Link href="SocialMedia">
Social Media
</Nav.Link>
</Nav.Item>

<Nav.Item>
<Nav.Link href="guestlist">
Guest List
</Nav.Link>
</Nav.Item>

<Nav.Item>
<Nav.Link href="artwork">
ArtWork
</Nav.Link>
</Nav.Item>

<Nav.Item>
<Nav.Link href="#">
Shipping / Load-In
</Nav.Link>
</Nav.Item>

<Nav.Item>
<Nav.Link href="#">
COI / Insurance
</Nav.Link>
</Nav.Item>

<Nav.Item>
<Nav.Link href="cataloguelisting">
Catalogue Listing
</Nav.Link>
</Nav.Item>

<Nav.Item>
<Nav.Link href="catalogueimage">
Catalogue Image
</Nav.Link>
</Nav.Item>

<Nav.Item>
<Nav.Link href="boothdesign">
Booth Design
</Nav.Link>
</Nav.Item>

<Nav.Item>
<Nav.Link href="#">
Exhibitors Badges
</Nav.Link>
</Nav.Item>
<h2>Virtual Presentation</h2>

<Nav.Item>
<Nav.Link href="#">
Saved Images
</Nav.Link>
</Nav.Item>

<Nav.Item>
<Nav.Link href="gallerylanding">
Landing Page
</Nav.Link>
</Nav.Item>

<Nav.Item>
<Nav.Link href="virtualbooths">
Virtual Booths
</Nav.Link>
</Nav.Item>
 
<hr/>

<Nav.Item>
<Nav.Link href="resources">
Resources
</Nav.Link>
</Nav.Item>

</Nav>

</>
);
}

